/* Doubled selectors outrank LeafyGreen's runtime-injected Emotion styles.
   Remove when these components migrate to Via. */
.settingsCardTitle.settingsCardTitle {
  margin: var(--via-space-600) 0 var(--via-space-400) 0;

  &:hover {
    &::after {
      opacity: 1;
      transition: opacity 150ms ease-in-out; /* transitionDuration.default */
    }
  }

  &::after {
    color: var(--via-color-neutral-600);
    content: "#";
    margin-left: var(--via-space-200);
    opacity: 0;
    transition: opacity 150ms ease-in-out; /* transitionDuration.default */
  }
}

.settingsCard.settingsCard {
  padding: var(--via-space-600);
  margin-bottom: 48px;
}
